Creates a new webhook subscription.
